module.exports = __webpack_public_path__ + "img/rose.89f149a5.jpg";